import { User } from 'types';
import { apiService } from './apiService';

export const getUser = async () => {
  try {
    return await apiService.get<User>('/user/profile');
  } catch (error) {
    return null;
  }
};
